import { render } from "./update_password.vue?vue&type=template&id=401e70e3&scoped=true"
import script from "./update_password.vue?vue&type=script&lang=js"
export * from "./update_password.vue?vue&type=script&lang=js"

import "./update_password.vue?vue&type=style&index=0&id=401e70e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401e70e3"]])

export default __exports__